(() => {
  class CloseoutTooltip extends HTMLElement {
    connectedCallback() {
      this._onLocalClick = this._onLocalClick.bind(this);
      this._onDocumentClick = this._onDocumentClick.bind(this);
      this._onAnotherOpen = this._onAnotherOpen.bind(this);

      this.addEventListener('click', this._onLocalClick);
      window.addEventListener('closeout:open', this._onAnotherOpen);

      this._triggerSelector = '[data-action="toggle-close-out-modal"]';
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onLocalClick);
      window.removeEventListener('closeout:open', this._onAnotherOpen);
      this._removeDocumentListener();
    }

    _getTrigger() {
      return this.querySelector(this._triggerSelector);
    }

    _getModal(triggerEl) {
      const trigger = triggerEl || this._getTrigger();
      if (!trigger) return null;

      const id = trigger.getAttribute('aria-controls');
      if (id) return this.querySelector(`#${CSS.escape(id)}`);
      return this.querySelector('.close-out-modal-floating');
    }

    _isOpen(modal) {
      return modal && !modal.hasAttribute('hidden');
    }

    open() {
      const trigger = this._getTrigger();
      const modal = this._getModal(trigger);
      if (!trigger || !modal) return;

      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');

      this._addDocumentListener();

      window.dispatchEvent(
        new CustomEvent('closeout:open', { detail: { source: this } })
      );
    }

    close() {
      const trigger = this._getTrigger();
      const modal = this._getModal(trigger);
      if (!trigger || !modal) return;

      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');

      this._removeDocumentListener();
    }

    toggle() {
      const trigger = this._getTrigger();
      const modal = this._getModal(trigger);
      if (!trigger || !modal) return;

      this._isOpen(modal) ? this.close() : this.open();
    }

    _addDocumentListener() {
      if (this._docListening) return;
      document.addEventListener('click', this._onDocumentClick, true);
      this._docListening = true;
    }

    _removeDocumentListener() {
      if (!this._docListening) return;
      document.removeEventListener('click', this._onDocumentClick, true);
      this._docListening = false;
    }

    _onLocalClick(e) {
      const trigger = e.target.closest(this._triggerSelector);
      if (!trigger || !this.contains(trigger)) return;

      e.preventDefault();
      this.toggle();
    }

    _onDocumentClick(e) {
      if (this.contains(e.target)) return;

      this.close();
    }

    _onAnotherOpen(e) {
      if (e.detail && e.detail.source && e.detail.source !== this) {
        this.close();
      }
    }
  }

  if (!customElements.get('closeout-tooltip')) {
    customElements.define('closeout-tooltip', CloseoutTooltip);
  }
})();